 
// @ts-nocheck
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
/* eslint-disable react/jsx-newline */
 
 
 
 
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';

import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
/*import PDFPreview from './components/PDFPreview';
import SettlementsTable from './components/SettlementsTable';*/
import SettlementsTable from './components/SettlementsTable/SettlementsTable';
import PDFPreview from './components/PDFPreview/PDFPreview';
import './index.css';
import { ConfigProvider } from 'antd';
const SettlementTransactions: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasSettlementTransactionsAddAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'SettlementTransactions')
  );
// Ant Design theme configuration
const theme = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 6,
    colorBgContainer: '#ffffff',
  },
};
  return (
    <CardContainer>
         <ConfigProvider theme={theme}>
      <Switch>
        <Route path={`${baseURL}/pdf-preview`}>
          <PDFPreview />
        </Route>
        <Route exact path={`${baseURL}`}>
          <SettlementsTable />
        </Route>
      </Switch>
      </ConfigProvider>
    </CardContainer>
  );
};

export { SettlementTransactions };
